import React from 'react';
import { BrowserRouter as Router, Switch, Route, Routes } from 'react-router';
import WebPage from './Private/WebPage';
import HomePage from './Pages/HomePage';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route index element={<WebPage component={HomePage} />} />
          <Route path="*" element={<WebPage component={HomePage} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
